import React, { createContext } from "react";
import { useEffect } from "react";
import { getData } from "../services/API";
import { useState } from "react";
import { getItemStorage } from "../Localstorage/useLocalStorage";

export const CartDataContext = createContext();

const CartContext = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [loaded, setLoaded] = useState(false)
  const [err, setErr] = useState(false)

  const token = getItemStorage("token")

  const updateCart = () => {
    getData("/shop/cart/index", {}, true)
      .then((res) => {
        setCart(res.data);
        setLoaded(true)
      })
      .catch((err) => {
        setErr(err.response.data)
        setLoaded(false)
      });
  };

  useEffect(() => {
    token && updateCart()
  }, [token]);

  return (
    <CartDataContext.Provider value={{ cart, setCart, updateCart, loaded, err }}>
      {children}
    </CartDataContext.Provider>
  );
};

export default CartContext;
